var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Node',{staticClass:"screen-node",attrs:{"node-id":_vm.nodeId,"icon":_vm.getScreenIcon,"shape":"capsule"}})}
var staticRenderFns = []

export { render, staticRenderFns }